import { z } from "zod";
export const helloDtoSchema = z.object({
    message: z.string(),
});
//# sourceMappingURL=hello.schema.js.map